// Translation for hu
export const hu = {
        common: {
            save: 'Mentés',
            cancel: 'Mégse',
            close: 'Bezárás',
            delete: 'Törlés',
            edit: 'Szerkesztés',
            activate: 'Aktiválás',
            add: 'Hozzáadás',
            saving: 'Mentés...',
            loading: 'Betöltés...',
            active: 'AKTÍV',
            inUse: 'Használatban',
            test: 'Teszt',
            searchApps: 'Alkalmazások keresése...',
            betaBanner: 'BETA - A szolgáltatás még nem elérhető!'
        },
        header: {
            creditBalance: 'Egyenleg',
            minutes: 'PERC'
        },
        auth: {
            signIn: 'Bejelentkezés',
            signUp: 'Regisztráció',
            username: 'Felhasználónév',
            password: 'Jelszó',
            continue: 'Folytatás',
            noAccount: 'Nincs fiókod?',
            hasAccount: 'Van már fiókod?',
            loginError: 'Bejelentkezési hiba',
            invalidCredentials: 'Érvénytelen felhasználónév vagy jelszó',
            rateLimited: 'Túl sok bejelentkezési kísérlet. Kérjük, várjon egy percet.',
            sessionExpired: 'A munkamenet lejárt. Kérjük, használjon új mágikus linket.',
            magicLinkInvalid: 'A bejelentkezési link érvénytelen vagy lejárt.',
            magicLinkSuccess: 'Üdvözöljük! Sikeresen bejelentkeztél.',
            magicLinkProcessing: 'Bejelentkezés feldolgozása...',
            connectionError: 'Kapcsolati hiba. Kérjük, próbálja újra.'
        },
        profile: {
            myProgress: 'Az Én Tanulási Haladásom',
            signOut: 'Kijelentkezés',
            plan: 'Csomag: '
        },
        settings: {
            title: 'Beállítások',
            tabs: {
                uiSettings: 'UI Beállítások',
                systemPrompt: 'Rendszerutasítás',
                llmProfiles: 'LLM Profilok',
                ttsProfiles: 'TTS Profilok',
                language: 'Nyelv',
            },
            uiSettings: {
                title: 'Felhasználói Felület',
                themeMode: 'Téma Mód',
                darkMode: 'Sötét Mód',
                lightMode: 'Világos Mód',
                themeColor: 'Téma Szín',
                themeColorDesc: 'Válassza ki a gombokhoz, ikonokhoz és kiemelésekhez szükséges hangsúlyszínt',
                background: 'Háttér',
                backgroundDesc: 'Válasszon hátteret a munkahelyéhez',
                selectBackgroundColor: 'Háttérszín Kiválasztása',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Fókusz',
                    concentration: 'Koncentráció',
                    relaxation: 'Relaxáció',
                    lianas: 'Liánok',
                    color: 'Szín'
                },
                backgroundColors: {
                    deepDark: 'Mély Sötét',
                    darkGrey: 'Sötét Szürke',
                    midnightBlue: 'Éjféli Kék',
                    indigo: 'Indigo',
                    darkTeal: 'Sötét Tálgyéj',
                    brown: 'Barna',
                    darkRed: 'Sötét Piros',
                    deepPurple: 'Mély Lila',
                    pureWhite: 'Tiszta Fehér',
                    softWhite: 'Puha Fehér',
                    lightGrey: 'Világos Szürke',
                    paleBlue: 'Halványkék',
                    paleGreen: 'Halványzöld',
                    paleOrange: 'Halványnarancs',
                    lavender: 'Levendula',
                    blueGrey: 'Kékszürke'
                }
            },
            systemPrompt: {
                label: 'Rendszerutasítás:',
                placeholder: 'Rendszerutasítás betöltése...',
                emptyError: 'A rendszerutasítás nem lehet üres!',
                saveSuccess: '✓ Rendszerutasítás sikeresen mentve!',
                loadError: 'Hiba a rendszerutasítás betöltésénél',
                saveError: 'Hiba a mentésnél'
            },
            llmProfiles: {
                addButton: '+ Új Kapcsolat Hozzáadása',
                newConnection: 'Új Kapcsolat',
                editConnection: 'Kapcsolat Szerkesztése',
                emptyState: 'Nincsenek elérhető LLM kapcsolatok. Kattintson az alábbiakra az hozzáadáshoz.',
                loadingProfiles: 'Profilok betöltése...',
                nameLabel: 'Név *',
                namePlaceholder: 'pl. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Kulcs *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Modell *',
                modelPlaceholder: 'gpt-4, mistral-tiny, stb.',
                allFieldsRequired: 'Az összes mezőt ki kell tölteni!',
                saveSuccess: '✓ Profil sikeresen mentve!',
                deleteConfirm: 'Biztosan törölni szeretne "{name}"-t?',
                profileNotFound: 'Profil nem található!',
                loadError: 'Hiba a profilok betöltésénél',
                saveError: 'Hiba a mentésnél',
                activateError: 'Hiba az aktiválásnál',
                deleteError: 'Hiba a törlésénél',
                modelInfo: 'Modell: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Új Hang Hozzáadása',
                newVoice: 'Új Hang',
                editVoice: 'Hang Szerkesztése',
                emptyState: 'Nincsenek elérhető TTS profilok. Kattintson az alábbiakra az hozzáadáshoz.',
                loadingProfiles: 'TTS profilok betöltése...',
                nameLabel: 'Név',
                namePlaceholder: 'pl. Az én ElevenLabs Adam',
                providerLabel: 'Szolgáltató',
                providerPlaceholder: 'pl. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Kulcs *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Modell ID *',
                modelIdPlaceholder: 'pl. eleven_monolingual_v1',
                voiceIdLabel: 'Hang ID',
                voiceIdPlaceholder: 'pl. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Az összes mezőt ki kell tölteni!',
                saveSuccess: '✓ TTS profil sikeresen mentve!',
                deleteConfirm: 'Biztosan törölni szeretne "{name}"-t?',
                loadError: 'Hiba a TTS profilok betöltésénél',
                saveError: 'Hiba a mentésnél',
                activateError: 'Hiba az aktiválásnál',
                deleteError: 'Hiba a törlésénél'
            },
            language: {
                title: 'Nyelvválasztás',
                description: 'Válassza ki a felhasználói felülethez előnyben részesített nyelvét'
            },
        },
        chat: {
            ready: 'Kész',
            start: 'KEZDÉS',
            stop: 'LEÁLLÍTÁS',
            initialMessage: 'Kattintson a KEZDÉS gombra a valós idejű beszélgetéshez.',
            listening: 'Hallgatás...',
            speaking: 'Thorsten beszél...',
            userLabel: 'Te',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Írja meg az üzenetet...',
            send: 'Küldés',
            loginRequired: 'Kérjük, jelentkezzen be a szolgáltatás használatához.',
            loginButton: 'Bejelentkezés Most',
            magicLinkRequired: 'Kérjük, használjon mágikus linket a bejelentkezéshez.',
            creditLimitError: 'Az óránkénti kvótája kimerült. Frissítse a csomagját (Medium/Premium) a folytatáshoz.',
            serviceDisabled: 'A csevegőszolgáltatás jelenleg nem érhető el. Kérjük, próbálja újra később.'
        },
        notifications: {
            error: 'Hiba',
            success: 'Siker',
            info: 'Információ',
            unknownError: 'Ismeretlen hiba történt'
        },
        cookie: {
            message: 'Ez a weboldal sütiket használ, hogy a lehető legjobb felhasználói élményt nyújtsa.',
            accept: 'Elfogadás'
        },
        curriculum: {
                buttonLabel: 'Tananyag',
                buttonTitle: 'Tananyag tartalom megjelenítése',
                modalTitle: '{app} Tananyag',
                sections: {
                    topic: 'Tananyag téma',
                    explanation: 'Gyerekbarát magyarázat',
                    studentProfile: 'Diák profil'
                },
                topic: {
                    empty: 'Ehhez a mikroalkalmazáshoz nincs tananyag téma kapcsolva a háttérrendszerben.',
                    missingDetail: 'A mikroalkalmazás részletes tananyag adatai még nem elérhetők a háttérrendszerben.',
                    learningGoals: 'Tanulási célok',
                    prerequisites: 'Előfeltételek',
                    unitLabel: 'Egység',
                    durationLabel: 'Időtartam',
                    difficultyLabel: 'Nehézség',
                    hours: 'óra',
                    minutes: 'perc'
                },
                explanation: {
                    empty: 'Nincs elérhető gyerekbarát magyarázat.',
                    loadingPrepare: 'Az AI előkészíti a magyarázatot',
                    loadingExplain: 'Az AI gyerekbarát nyelven magyarázza el a témát',
                    requestFailed: 'A gyerekbarát magyarázat nem generálható.'
                },
                studentProfile: {
                    country: 'Ország',
                    region: 'Állam / Régió',
                    schoolType: 'Iskola típusa',
                    grade: 'Osztály',
                    noContext: 'Nincs diák kontextus.',
                    childProfileNotFound: 'A jelenlegi bejelentkezéshez nem található diák profil a háttérrendszerben.',
                    loginProfileIncomplete: 'A bejelentkezési profil még nem tartalmaz teljes diák kontextust.',
                    educationContextNotFound: 'Diák profil található, de nincs tananyag hozzárendelés beállítva.',
                    noToken: 'Nincs bejelentkezett diák.'
                },
                errors: {
                    signInRequired: 'Kérjük, jelentkezzen be a tananyag megtekintéséhez.',
                    appIdMissing: 'Az alkalmazás azonosító hiányzik.',
                    loadFailed: 'A tananyag adatok betöltése nem sikerült.'
                }
            }
    };
